var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import moment from 'moment';
import { Column } from 'primereact/column';
import { Button } from 'primereact/components/button/Button';
import { DataTable } from 'primereact/datatable';
import * as React from 'react';
import ApiRequests from '../../../classes/http/ApiRequests';
import NotosService from '../../../classes/notos.service';
import Config from '../../../config/config';
import './Grid.css';
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            filters: {},
            sortField: '',
            sortOrder: 0,
            isCategory: false,
            currentVal: '',
        };
        _this.imageFormatter = function (rowData, column) {
            return React.createElement("img", { src: Config.cdnDomain + rowData[column.field], style: { height: '80px' }, alt: "" });
        };
        _this.linkFormatter = function (rowData, column) {
            return Config.cdnDomain + rowData[column.field];
        };
        _this.dateFormatter = function (rowData, column) {
            return moment(rowData[column.field]).local().format(NotosService.dateMomentFormat);
        };
        _this.booleanFormatter = function (rowData, column) {
            return rowData[column.field] ? 'Да' : 'Не';
        };
        _this.deliveryMethodFormatter = function (rowData, column) {
            return NotosService.formatDeliveryTypes(rowData[column.field]);
        };
        _this.promoCodeFormatter = function (rowData, column) {
            return NotosService.formatPromoCodeTypes(rowData[column.field]);
        };
        _this.filterTypeFormatter = function (rowData, column) {
            return NotosService.formatFilterTypes(rowData[column.field]);
        };
        _this.aromaticNoteTypeFormatter = function (rowData, column) {
            return NotosService.formatAromaticNoteTypes(rowData[column.field]);
        };
        _this.positionBody = function (rowData) {
            return (React.createElement("div", { style: { marginRight: '65px' } },
                React.createElement("input", { type: "text", className: "p-inputtext p-component", onChange: function (e) { return _this.setState({ currentVal: e.target.value }); } }),
                React.createElement("button", { className: "btn btn-primary", onClick: function () {
                        var productId = rowData.id;
                        var url = window.location.href;
                        var segments = url.split('/');
                        var length = url.endsWith('/') ? segments.length - 1 : segments.length;
                        var categoryId = segments[length - 2];
                        var api = new ApiRequests();
                        if (_this.state.currentVal) {
                            api.updateCategoryProduct({ category_product: { position: Number(_this.state.currentVal) } }, categoryId, productId).then(function (res) { return window.location.reload(); });
                        }
                    } }, "\u0417\u0430\u043F\u0438\u0448\u0438")));
        };
        _this.renderColumns = function () {
            var dynamicColumns = [];
            // tslint:disable-next-line:prefer-for-of
            for (var i = 0; i < _this.props.columns.length; i++) {
                var body = void 0;
                switch (_this.props.columns[i].formatter) {
                    case 'image':
                        body = _this.imageFormatter;
                    case 'linkFormatter':
                        body = _this.linkFormatter;
                        break;
                    case 'date':
                        body = _this.dateFormatter;
                        break;
                    case 'boolean':
                        body = _this.booleanFormatter;
                        break;
                    case 'deliveryMethod':
                        body = _this.deliveryMethodFormatter;
                        break;
                    case 'promoCodeMethod':
                        body = _this.promoCodeFormatter;
                        break;
                    case 'filterTypes':
                        body = _this.filterTypeFormatter;
                        break;
                    case 'aromaticNoteTypes':
                        body = _this.aromaticNoteTypeFormatter;
                        break;
                    default:
                        body = null;
                }
                dynamicColumns.push(React.createElement(Column, { key: _this.props.columns[i].key, field: _this.props.columns[i].key, header: _this.props.columns[i].name, sortable: _.get(_this.props.columns[i], 'sort', true) !== false, filter: _.get(_this.props.columns[i], 'filter', true) !== false, filterMatchMode: "contains", body: body, style: { textOverflow: 'ellipsis' } }));
            }
            // Adding actions column only if there are action parameters
            if (_this.props.deleteAction || _this.props.editAction || _this.props.viewAction) {
                dynamicColumns.push(React.createElement(Column, { key: "Actions", header: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F", body: _this.actionTemplate, className: "actionBtns", style: { textAlign: 'center', width: '150px' }, field: "actionsColumn" // must have 'field' in order to produce proper column reordering
                 }));
            }
            if (window.location.href.includes('category') && !_this.props.disableCategoryExtraColumn) {
                dynamicColumns.push(React.createElement(Column, { key: "position", header: "\u041F\u043E\u0437\u0438\u0446\u0438\u044F", body: _this.positionBody, className: "actionBtns", style: { textAlign: 'center', width: '150px' }, field: "actionsColumn" // must have 'field' in order to produce proper column reordering
                 }));
            }
            return dynamicColumns;
        };
        _this.actionTemplate = function (rowData, column) {
            var rowId = rowData.Id;
            var buttons = (React.createElement(React.Fragment, null,
                _this.props.editAction ? (React.createElement(Button, { type: "button", id: 'edit_' + rowId, style: { border: 'none', marginRight: '5px' }, onClick: function () { return _this.props.editAction(rowData); }, icon: "fa fa-edit", tooltip: 'Редактиране', tooltipOptions: { position: 'top' } })) : null,
                _this.props.deleteAction ? (React.createElement(Button, { type: "button", id: 'delete_' + rowId, style: { background: '#f86c6b', border: 'none' }, onClick: function () { return _this.props.deleteAction(rowData); }, icon: "fa fa-times", tooltip: 'Изтриване', tooltipOptions: { position: 'top' } })) : null,
                _this.props.viewAction ? (React.createElement(Button, { type: "button", id: 'view' + rowId, style: { background: '#33cc99', border: 'none' }, onClick: function () { return _this.props.viewAction(rowData); }, icon: "fa fa-eye", tooltip: 'Преглед', tooltipOptions: { position: 'top' } })) : null));
            return buttons;
        };
        _this.onFilter = function (event) {
            // TODO
        };
        _this.onSort = function (event) {
            // TODO
        };
        return _this;
    }
    Grid.prototype.render = function () {
        return (React.createElement(DataTable, { paginator: this.props.paginator, rows: this.props.rows, onPage: this.props.onPage, onSort: this.onSort, onFilter: this.onFilter, filters: this.state.filters, lazy: this.props.lazy, first: this.props.first, totalRecords: this.props.total, value: this.props.data, sortMode: "multiple", sortField: this.state.sortField, sortOrder: this.state.sortOrder, resizableColumns: true, responsive: true, reorderableColumns: this.props.reordable, emptyMessage: 'Няма намерени резултати.', header: this.props.header }, this.renderColumns()));
    };
    return Grid;
}(React.Component));
export default Grid;



//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Grid/Grid.tsx
// module id = 14
// module chunks = 0